// 2d地图主体框架
<template>
    <div class="abs full abs-operate">
        <div class="abs full abs-map" :style="{width: width}" >
            <div ref="map" class="map full" ></div>
            
            <!-- 弹出框 -->
            <div ref="popup">
                <Render v-if="popupRequest.isOpen"/>
            </div>
            <!-- 等待地图初始化完毕 -->
            <slot v-if="ready" />
        </div>
    </div>
</template>

<script>

import { Render } from './Popup';
import mapmixin from '@/mixins/mapmixin.js'
import scenariomixin from '@/mixins/scenariomixin.js'
import events from './events'
import { MapView } from './mapView.js'
import PopupRequest from './PopupRequest';
export default {
    mixins: [mapmixin, scenariomixin, events],
    components: { Render, },
    provide() {
            return {
                MapView: MapView,
            }
    },
    unWatch() {
        return {
            popup: null,
        };
    },
    data () {
        return {
            width: "100%",
            popupRequest: new PopupRequest(),
        }
    },
    watch: {
        'popupRequest.popupCount'(val, preV) {
            this.popup.remove();
            if (val > preV) {
                const { coord, offset } = this.popupRequest;
                this.popup.options.offset = [...offset];
                this.popup.setLngLat(coord);
                this.popup.addTo(this.MapView.map);

                // 非图幅范围内自动定位
                const center = this.popup.getLngLat();
                if (
                    !this.MapView.map
                        .getBounds()
                        .contains(center.lng, center.lat)
                ) {
                    this.MapView.map.setCenter(center);
                }
            } else {
                this.popupRequest.reset();
            }
        },
    },
    mounted() {
        // 初始化popup对象
        this.popup = MapView.newPopup(this.$refs.popup);
        MapView.initMap(this,this.$refs.map).then(map2d => {
            // 测试模式提供
            global.map_dev = map2d
            this.bindShareData()

            this.$store.commit('map/setReadyState', true)
            this.$_scenarioChange(this.scenario)

        })
        EVENTHUB.on('setDataEditEnd', this.$_setMapWidth)
        EVENTHUB.on('setMapWidth', this.$_setMapWidthB)
    },
    beforeDestroy(){
        //用于切换后台路由时加载组件 顺序不对得情况, 设置等待地图初始化完毕 再加载其他组件
        this.$store.commit('map/setReadyState', false)
    },
    methods: {
        $_scenarioChange(scenario) {
            if (this.ready) {
                MapView.clearGroup()
                // MapView.map.on('zoomend',this.zoomEnd)
                // 不读取3d方案
                if (scenario !== 'globe') {
                    this.$_getCurrentScenario().then(layers => {
                        MapView.addLayers2Group(layers)
                    })
                }
            }
        },
        $_setMapWidthB(){
            this.width = "100%"
        },
        $_setMapWidth(){
            this.width = "80%"
        },
        zoomEnd(e){
            let zoom_control = document.getElementsByClassName('mapboxgl-ctrl-zoom')[0]
            const level = MapView.map.getZoom() + 1
            console.log(level,"层级")
            zoom_control.innerHTML = parseInt(level)
        },
    }
}
</script>
<style>

.abs-operate{
    width: 100%;
    right: 0px;
    height: 100%;
}
.abs-map{
    height: 100%;
    right: 0px;
}

</style>
